import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import Integrations from "../../../integration/Integrations";

class QuoteCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            quote: this.props.quote || null,
            proposal: this.props.proposal || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            <div className="col-12">
                {
                    this.props.quote.attributes.externalSourceIntegrationKey ?
                        <FormattedMessage
                            id="quote.analytics.events.quote_requested_text"
                            defaultMessage="Quote {quoteIdentifier} has been requested from {integrationName}"
                            values={{
                                quoteIdentifier: this.state.object.attributes.identifier,
                                integrationName: Integrations.getIntegrationNameFromKey(this.props.quote.attributes.externalSourceIntegrationKey),
                            }}
                        /> :
                        <FormattedMessage
                            id="quote.analytics.events.quote_created_text"
                            defaultMessage="Proposal {identifier} has been created"
                            values={{
                                identifier: this.state.object.attributes.identifier
                            }}
                        />
                }
            </div>
        </div>
    }

}

export default QuoteCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-created.component.jsx